import React, { useState } from 'react';
import { Radio, RadioGroup, FormControlLabel, FormControl, Button, Modal, Box, IconButton } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import CloseIcon from '@mui/icons-material/Close';
import ViewTemplates from './ViewTemplates';
import UploadCertificateFiles from './UploadCertificateFiles';
import "./Certificates.css";
import ViewSignature from './ViewSignature';
import ViewLogos from './ViewLogos';

const style = {
  position: 'absolute',
  top: '40%',
  left: '51%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: '540px',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  overflowY: 'auto',
  borderRadius: 2,
};

const Certificates = () => {  
  const [selectedValue, setSelectedValue] = useState('templates');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div className='certificates'>
      <div className='certificates-header'>
          <div>
            <FormControl component="fieldset">              
              <RadioGroup
                row
                aria-label="options"
                name="controlled-radio-buttons-group"
                value={selectedValue}
                onChange={handleChange}
              >
                <FormControlLabel value="templates" control={<Radio />} label="Templates" />
                <FormControlLabel value="signatures" control={<Radio />} label="Signatures" />
                <FormControlLabel value="logos" control={<Radio />} label="Logos" />
              </RadioGroup>
            </FormControl>
          </div>
          <div>
            <Button
              variant="contained"
              startIcon={<UploadIcon />} 
              onClick={handleOpen}             
            >
              Upload
            </Button>
          </div>
      </div>
      <div>        
        <Modal 
          open={open}           
          disableEscapeKeyDown
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              handleClose();
            }
          }}
        >
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <UploadCertificateFiles />
          </Box>
        </Modal>
        {selectedValue === 'templates' && <ViewTemplates />}
        {selectedValue === 'signatures' && <ViewSignature />}
        {selectedValue === 'logos' && <ViewLogos />}        
      </div>            
    </div>
  );
};

export default Certificates;
